/**
 * Puts a `/profile/update` response straight into the shared `/profile/get`
 * query cache entry. `/follows/set` and `/profile/update` only invalidate
 * that query on a 150 ms debounce rather than seeding it, and the root
 * OnboardingGate cannot wait that long: it reads the cache the instant its
 * query re-enables.
 */
import type { QueryClient } from "@tanstack/react-query";

export const PROFILE_GET_QUERY_KEY: readonly string[] = [
  "post:profile:profileGet",
  "svc:profile-api",
];

export function writeProfileThrough(input: {
  queryClient: QueryClient;
  response: { data?: null | { profile?: unknown } } | null | undefined;
}): boolean {
  const profile = input.response?.data?.profile ?? null;
  if (profile === null) return false;
  input.queryClient.setQueryData(PROFILE_GET_QUERY_KEY, {
    error: null,
    data: { profile },
  });
  return true;
}
